// extracted by mini-css-extract-plugin
export default {"createProjectButton":"CreateProjectButtonEmptyWS_createProjectButton__jWdBh"};